import { Text, View } from "@react-pdf/renderer";
import { wasteQualityStyleSheet } from "../styles/wasteQualityStyleSheet";

export const WasteQualityLegend = ({ data, direction, marginTop }) => {
  const materials = (data?.materialsTemporalData || []).filter(Boolean);
  const isRowDirection = direction === "row";

  return (
    <View
      style={{
        flexDirection: isRowDirection ? "row" : "column",
        flexWrap: isRowDirection ? "wrap" : "nowrap",
        width: "100%",
        marginTop: marginTop ?? 20,
      }}
    >
      {materials.map((material, index) => (
        <View
          key={material.value || material.nameAndCount || index}
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginRight: 10,
            marginBottom: 5,
            maxWidth: "100%",
          }}
          wrap={false}
        >
          <View
            style={{
              width: 8,
              height: 8,
              borderRadius: 4,
              marginRight: 5,
              backgroundColor: material.color,
              flexShrink: 0,
            }}
          />
          <Text style={wasteQualityStyleSheet.legendText}>
            {material.nameAndCount}
          </Text>
        </View>
      ))}
    </View>
  );
};
